export default __webpack_public_path__ + "static/media/userIconBlue.937c71f4.svg";